import API_ROUTES from 'services/apiRoutes';
import { buildQueryParams, DEFAULT_CLIENT_ID } from 'helpers/utils';
import { FiltersData } from 'store/filters/types';
import { siteApi } from './siteApi';

export const filtersApi = siteApi.injectEndpoints({
  endpoints: builder => ({
    getFilters: builder.query<FiltersData, { client_id?: number }>({
      query: ({ client_id }) => {
        // client_id 104 (HDD) is an OATH owned client. this is a short term fix until OATH-3896 is implemented
        const params = buildQueryParams({
          client_id: client_id === 104 ? DEFAULT_CLIENT_ID : client_id,
        });
        return `${API_ROUTES.GET_FILTERS}${params}`;
      },
    }),
  }),
  overrideExisting: 'throw',
});

export const { useGetFiltersQuery, useLazyGetFiltersQuery } = filtersApi;
